import {
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostBinding
} from '@angular/core';
import { MediaCell } from '../../carousel-media-cell/carousel-media-cell.component';

@Component({
  selector: 'lib-other-wrapper',
  templateUrl: './other-wrapper.component.html',
  styleUrls: ['./other-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OtherWrapperComponent {
  @Output() isLoadingEmitter: EventEmitter<boolean> = new EventEmitter();
  @Input() objectFit = '';
  @Input()
  get file(): MediaCell {
    return this._file }
  set file(val: MediaCell) {
    this._file = val;
  }
  @Input() isGalleryManager = false;
  @HostBinding('class.photo-manager-placeholder') get galleryManager() {
    return this.isGalleryManager;
  }
  private _file: MediaCell = { src: '', type: 'text' };
  constructor() { }


  getFilename(file: MediaCell) {
    return decodeURIComponent(file.src.split('/').pop() as string);
  }

  getFileExtension(file: MediaCell) {
    return file.src.split('.').pop();
  }

}
